// extracted by mini-css-extract-plugin
export default {"container":"TodoApp_container__ZM6Fu"};